/**
 * VENDOR MODULES
 */
import React from 'react';

/**
 * Just print the no odds labels
 *
 * @class      NoOddsLabels (name)
 * @return     {DOM}
 */
function NoOddsLabels() {
    return (
        <div className="no-odds-text">Scommessa non quotata per questo evento</div>
    );
}

export default NoOddsLabels;

